module.exports = __webpack_public_path__ + "static/media/info.f6fcba34.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/alerts/info.svg
// module id = 313
// module chunks = 0